import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetalleSolicitudMultiComponent } from './components/individual-retreat/request-list-notifi/DetalleSolicitudMulti/detalleSolicitudMulti.component';
import { MultiBeneficiarioComponent } from './components/individual-retreat/request-list-notifi/multibeneficiario/multibeneficiario.component';
import { LoginComponent } from './components/login/login.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { RoutingPath } from './configs/routing-path';
import { LoggedInGuard } from './core/guards/logged-in/logged-in.guard';
import { NoLoggedGuard } from './core/guards/no-logged/no-logged.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { DetalleSolicitudDevolucionComponent } from '../app/components/individual-retreat/request-list-notifi/DetalleSolicitudDevolucion/detalle-solicitud-devolucion.component'


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    redirectTo: RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path,
    pathMatch: 'full',
  },
  {
    path: RoutingPath.appRouting.components.dashboard.path,
    redirectTo: RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path,
    pathMatch: 'prefix'
  },
  {
    path: RoutingPath.appRouting.components.invidivual_affiliation.path,
    redirectTo: RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.mass_affiliation.path,
    redirectTo: RoutingPath.appRouting.components.mass_affiliation.path + '/' + RoutingPath.appRouting.components.mass_affiliation.pages.home.path,
    pathMatch: 'prefix'
  },
  {
    path: RoutingPath.appRouting.components.individual_retreat.path,
    redirectTo: RoutingPath.appRouting.components.individual_retreat.path + '/' + RoutingPath.appRouting.components.individual_retreat.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.beneficiary_removal.path,
    redirectTo: RoutingPath.appRouting.components.beneficiary_removal.path + '/' + RoutingPath.appRouting.components.beneficiary_removal.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.mass_retreat.path,
    redirectTo: RoutingPath.appRouting.components.mass_retreat.path + '/' + RoutingPath.appRouting.components.mass_retreat.pages.home.path,
    pathMatch: 'prefix'
  },

  {
    path: RoutingPath.appRouting.components.acreditacion_cuota.path,
    redirectTo: RoutingPath.appRouting.components.acreditacion_cuota.path + '/' + RoutingPath.appRouting.components.acreditacion_cuota.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: RoutingPath.appRouting.components.discapacidad.path,
    redirectTo: RoutingPath.appRouting.components.discapacidad.path + '/' + RoutingPath.appRouting.components.discapacidad.pages.home.path,
    pathMatch: 'prefix',
  },
  {
    path: 'iPlanetDirectoryPro/:idToken',
    canActivate: [NoLoggedGuard],
    component: NotAuthorizedComponent
  },
  {
    path: 'no-autorizado',
    component: NotAuthorizedComponent,
    canActivate: [NoLoggedGuard],
  },
  {
    path: RoutingPath.appRouting.components.dashboard.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: RoutingPath.appRouting.components.business_information.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/business-information/business-information.module').then(m => m.BusinessInformationModule)
  },
  {
    path: RoutingPath.appRouting.components.acreditacion_cuota.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/acreditacion-cuota-monetaria/acreditacion-cuota-monetaria.module').then(m => m.AcreditacionCuotaMonetariaModule)
  },
  {
    path: RoutingPath.appRouting.components.discapacidad.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/discapacidad/discapacidad.module').then(m => m.DiscapacidadModule)
  },
  {
    path: RoutingPath.appRouting.components.invidivual_affiliation.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/individual-affiliation/individual-affiliation.module').then(m => m.IndividualAffiliationModule)
  },
  {
    path: RoutingPath.appRouting.components.mass_affiliation.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/mass-affiliation/mass-affiliation.module').then(m => m.MassAffiliationModule)
  },
  {
    path: RoutingPath.appRouting.components.individual_retreat.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/individual-retreat/individual-retreat.module').then(m => m.IndividualRetreatModule)
  },
  {
    path: RoutingPath.appRouting.components.afiliate_beneficiary.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/individual-afiliate-beneficiary/individual-afiliate-beneficiary.module').then(m => m.IndividualAfiliateBeneficiaryModule)
  },
  {
    path: RoutingPath.appRouting.components.beneficiary_removal.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/beneficiary-removal/beneficiary-removal.module').then(m => m.BeneficiaryRemovalModule)
  },
  {
    path: RoutingPath.appRouting.components.mass_retreat.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/mass-retreat/mass-retreat.module').then(m => m.MassRetreatModule)
  },
  {
    path: RoutingPath.appRouting.components.workers_information.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/workers-information/workers-information.module').then(m => m.WorkersInformationModule)
  },
  {
    path: RoutingPath.appRouting.components.workers_information.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/cambio-estado-civil/cambio-estado-civil.module').then(m => m.ChangeMaritalStatusModule)
  },
  {
    path: RoutingPath.appRouting.components.user.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/user/user.module').then(m => m.UserModule)
  },
  {
    path: RoutingPath.appRouting.components.certificates.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/certificates/certificates.module').then(m => m.CertificatesModule)
  }, {
    path: RoutingPath.appRouting.components.affiliates_process.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/affiliates/affiliates.module').then(m => m.AffiliatesModule)
  }, {
    path: RoutingPath.appRouting.components.pqrs.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/pqrs/pqrs.module').then(m => m.PqrsModule),
    data: {
      breadcrumb: RoutingPath.appRouting.components.pqrs.breadcrumb
    }
  },
  {
    path: RoutingPath.appRouting.components.mass_queries.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/mass-queries/mass-queries.module').then(m => m.MassQueriesModule)
  },
  {
    path: RoutingPath.appRouting.components.subsidy.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/subsidy/subsidy.module').then(m => m.SubsidyModule)
  },
  {
    path: RoutingPath.appRouting.components.disaffiliate_query.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/disaffiliate-query/disaffiliate-query.module').then(m => m.DisaffiliateQueryModule)
  },
  {
    path: RoutingPath.appRouting.components.affiliate_query.path,
    component: MainLayoutComponent,
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./components/disaffiliate-query/disaffiliate-query.module').then(m => m.DisaffiliateQueryModule)
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'multi-beneficiarios/:code',
        component: MultiBeneficiarioComponent
      },
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'detalle-solicitud/:id',
        component: DetalleSolicitudMultiComponent
      },
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'detalle-solicitud-devolucion/:id',
        component: DetalleSolicitudDevolucionComponent
      },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
